<template>
	<AnalysisChart
		endpoint="web/get-body-weight-analysis"
		data-key="total_weight"
		standard-key="standard_weight"
		series-label="Body Weight"
		standard-label="Standard Body Weight"
		yaxis-title="Weight (g)"
	/>
</template>

<script>
import AnalysisChart from "../components/AnalysisChart.vue";

export default {
	components: { AnalysisChart },
};
</script>
